export const P00076AjustementTypeEnum = [
  { ref: 0, label: '0%' },
  { ref: 10, label: '10%' },
  { ref: 20, label: '20%' },
  { ref: 30, label: '30%' },
  { ref: 40, label: '40%' },
  { ref: 50, label: '50%' },
  { ref: 60, label: '60%' },
  { ref: 70, label: '70%' },
  { ref: 80, label: '80%' },
  { ref: 90, label: '90%' },
  { ref: 100, label: '100%' },
];
